import { guardQuickSubmitCandidateSelection } from './api';

export const config = {
  title: 'Submit',
  okText: 'Submit',
  // Each dropdown row is two lines across three columns: identity, a dates
  // rail (Created / Updated) and the status badge. 560 squeezed the identity
  // column once the dates rail earned its own space; 640 lets a full name +
  // designation + email sit beside both dates without truncating.
  width: 640,
  disabledUntilFilled: true,
  // Source Candidates' "Quick Submit" row action already knows both the job
  // (via popupState.jobId) and the candidate (the selected row) - nothing
  // left to ask, so redirect straight to QuickSubmitForm instead of showing
  // an empty confirm dialog (see quick-submit/api.js's submit()).
  autoSubmitWhenNoFields: true,
  getNote: (context) =>
    context.moduleName === 'candidate'
      ? 'Note: Select a job to submit this candidate.'
      : 'Note: Select a candidate to submit for this job',
  getFields: (context) =>
    // Caller already knows the job (e.g. Source Candidates' row action passes
    // { jobId } via searchActionContext) AND the candidate is the selected
    // row - nothing left to ask.
    context.jobId
      ? []
      : context.moduleName === 'candidate'
      ? [
          {
            name: 'jobId',
            label: 'Job list',
            type: 'search-select',
            required: true,
            placeholder: 'Search Job ID / job name - or pick a recent job',
            searchFetchKey: 'quickSubmitJobList',
            optionLayout: {
              id: '{jobReferenceId}',
              title: '{jobTitle}',
              subtitle: '{clientJobReferenceId}',
              meta: [
                { label: 'Created', key: 'createdAt', type: 'date' },
                { label: 'Updated', key: 'updatedAt', type: 'relative' },
              ],
            },
          },
        ]
      : [
          {
            name: 'candidate',
            label: 'Candidate',
            type: 'search-select',
            required: true,
            placeholder: 'Search candidate name / email - or pick a recent candidate',
            optionsKey: 'candidateOptions',
            searchFetchKey: 'quickSubmitCandidates',
            labelTemplate: '{applicantRefrenceId} - {firstName} {lastName} - {createdAgo}',
            valueKey: 'applicantId',
            optionLayout: {
              id: '{applicantRefrenceId}',
              title: '{firstName} {lastName}',
              titleAccent: {
                key: 'createdAgo',
                toneKey: 'createdAgoTone',
                prefix: ' - ',
              },
              subtitle: '{designation} - {email}',
              meta: [
                { label: 'Created', key: 'createdAt', type: 'date' },
                { label: 'Updated', key: 'updatedAt', type: 'relative' },
              ],
            },
            onSelectGuard: guardQuickSubmitCandidateSelection,
          },
        ],
};
